module.exports = __webpack_public_path__ + "img/plus.59932a02.svg";